<template>
  <div>
    <img v-if="currentPage > 1" :data-src="backIcon" class="icon-dimensions rotate add-pointer"
         @click="onPreviousClicked"
         @mouseenter="resolveHover('back', true)"
         @mouseleave="resolveHover('back', false)"
         uk-img>
    <img v-else :data-src="disabledLeftIcon" class="dimensions" uk-img>
    <span class="page-indicator">{{$t('general.page')}} {{currentPage}}</span>
    <img v-if="nextEnabled" :data-src="forwardIcon" class="icon-dimensions add-pointer"
         @click="onNextClicked"
         @mouseenter="resolveHover('forward', true)"
         @mouseleave="resolveHover('forward', false)"
         uk-img>
    <img v-else :data-src="disabledRightIcon" class="dimensions" uk-img>
  </div>
</template>
<script>
  import * as event from '../../enums/mixpanel-event'
  import iconUtil from '../../utils/icon-util'
  import * as misc from '../../enums/misc'
  import mixpanel from '../../services/mixpanel'

  export default {
    name: 'pagination',
    props: ['currentPage', 'nextEnabled'],
    data() {
      return {
        forwardIcon: iconUtil.resolve(misc.PAGING_ENABLED),
        backIcon: iconUtil.resolve(misc.PAGING_ENABLED),
        disabledLeftIcon: iconUtil.resolve(misc.PAGING_DISABLED_LEFT),
        disabledRightIcon: iconUtil.resolve(misc.PAGING_DISABLED_RIGHT),
        back: 'back',
        forward: 'forward'
      }
    },
    methods: {
      onNextClicked() {
        this.$emit('fetchNextBatch')
        mixpanel.track(event.PAGED_NEXT)
      },
      onPreviousClicked() {
        this.$emit('fetchPreviousBatch')
        mixpanel.track(event.PAGED_BACK)
      },
      resolveHover(paging, hover) {
        if (paging === this.back) {
          if (hover) {
            this.backIcon = iconUtil.resolve(misc.PAGING_HOVER)
          } else {
            this.backIcon = iconUtil.resolve(misc.PAGING_ENABLED)
          }
        } else if (paging === this.forward) {
          if (hover) {
            this.forwardIcon = iconUtil.resolve(misc.PAGING_HOVER)
          } else {
            this.forwardIcon = iconUtil.resolve(misc.PAGING_ENABLED)
          }
        }
      }
    }
  }
</script>
<style lang="scss" scoped>

  .page-indicator {
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: rgba(0, 1, 2, 0.7);
    padding-left: 10px;
    padding-right: 10px;
  }

  .icon-dimensions {
    width: 14px;
    height: 31px;
  }

  .rotate {
    transform: rotate(180deg);
  }
</style>
